//RIGHT
import blueExclamationCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/blueExclamationCrownToRight.svg";
import greenExclamationCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/greenExclamationCrownToRight.svg";
import yellowExclamationCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/yellowExclamationCrownToRight.svg";
import pinkExclamationCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/pinkExclamationCrownToRight.svg";

//LEFT
import blueExclamationCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/blueExclamationCrownToLeft.svg";
import greenExclamationCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/greenExclamationCrownToLeft.svg";
import yellowExclamationCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/yellowExclamationCrownToLeft.svg";
import pinkExclamationCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/pinkExclamationCrownToLeft.svg";

//RIGHT
import blueQuestionCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/blueQuestionCrownToRight.svg";
import greenQuestionCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/greenQuestionCrownToRight.svg";
import yellowQuestionCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/yellowQuestionCrownToRight.svg";
import pinkQuestionCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/pinkQuestionCrownToRight.svg";

//LEFT
import blueQuestionCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/blueQuestionCrownToLeft.svg";
import greenQuestionCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/greenQuestionCrownToLeft.svg";
import yellowQuestionCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/yellowQuestionCrownToLeft.svg";
import pinkQuestionCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/pinkQuestionCrownToLeft.svg";

//RIGHT
import blueSquareCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/blueSquareCrownToRight.svg";
import greenSquareCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/greenSquareCrownToRight.svg";
import yellowSquareCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/yellowSquareCrownToRight.svg";
import pinkSquareCrownToRight from "../../../../assets/icons/dilemmaOwnerCrowns/pinkSquareCrownToRight.svg";

//LEFT
import blueSquareCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/blueSquareCrownToLeft.svg";
import greenSquareCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/greenSquareCrownToLeft.svg";
import yellowSquareCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/yellowSquareCrownToLeft.svg";
import pinkSquareCrownToLeft from "../../../../assets/icons/dilemmaOwnerCrowns/pinkSquareCrownToLeft.svg";

const getDilemmaOwnerCrownImage = (playerColor: string, crownType: string, angleInDegrees: number) => {
    let crownBasedOnUserColor: any;

    if (angleInDegrees === 180) {
        if (crownType === "question") {
            switch (playerColor) {
                case "pink": {
                    crownBasedOnUserColor = pinkQuestionCrownToLeft;
                    break;
                }
                case "blue": {
                    crownBasedOnUserColor = blueQuestionCrownToLeft;
                    break;
                }
                case "green": {
                    crownBasedOnUserColor = greenQuestionCrownToLeft;
                    break;
                }
                case "yellow": {
                    crownBasedOnUserColor = yellowQuestionCrownToLeft;
                }
            }
            return crownBasedOnUserColor;
        }

        if (crownType === "action") {
            switch (playerColor) {
                case "pink": {
                    crownBasedOnUserColor = pinkExclamationCrownToLeft;
                    break;
                }
                case "blue": {
                    crownBasedOnUserColor = blueExclamationCrownToLeft;
                    break;
                }
                case "green": {
                    crownBasedOnUserColor = greenExclamationCrownToLeft;
                    break;
                }
                case "yellow": {
                    crownBasedOnUserColor = yellowExclamationCrownToLeft;
                }
            }
            return crownBasedOnUserColor;
        }

        if (crownType === "initial") {
            switch (playerColor) {
                case "pink": {
                    crownBasedOnUserColor = pinkSquareCrownToLeft;
                    break;
                }
                case "blue": {
                    crownBasedOnUserColor = blueSquareCrownToLeft;
                    break;
                }
                case "green": {
                    crownBasedOnUserColor = greenSquareCrownToLeft;
                    break;
                }
                case "yellow": {
                    crownBasedOnUserColor = yellowSquareCrownToLeft;
                }
            }
            return crownBasedOnUserColor;
        }
    }

    switch (playerColor) {
        case "pink": {
            if (crownType === "initial")
                crownBasedOnUserColor = pinkSquareCrownToRight;

            if (crownType === "action")
                crownBasedOnUserColor = pinkExclamationCrownToRight;

            if (crownType === "question")
                crownBasedOnUserColor = pinkQuestionCrownToRight;
            break;
        }
        case "blue": {
            if (crownType === "initial")
                crownBasedOnUserColor = blueSquareCrownToRight;

            if (crownType === "action")
                crownBasedOnUserColor = blueExclamationCrownToRight;

            if (crownType === "question")
                crownBasedOnUserColor = blueQuestionCrownToRight;
            break;
        }
        case "green": {
            if (crownType === "initial")
                crownBasedOnUserColor = greenSquareCrownToRight;

            if (crownType === "action")
                crownBasedOnUserColor = greenExclamationCrownToRight;

            if (crownType === "question")
                crownBasedOnUserColor = greenQuestionCrownToRight;
            break;
        }
        case "yellow": {
            if (crownType === "initial")
                crownBasedOnUserColor = yellowSquareCrownToRight;

            if (crownType === "action")
                crownBasedOnUserColor = yellowExclamationCrownToRight;

            if (crownType === "question")
                crownBasedOnUserColor = yellowQuestionCrownToRight;
            break;
        }
    }

    return crownBasedOnUserColor;
}

export default getDilemmaOwnerCrownImage;